/* eslint-disable no-unused-vars */
/* global __webpack_public_path__: true */
__webpack_public_path__ = "./dist/";
import "../src/main";
